/*
  Taabiir mega menu — hover intent.

  Dawn's mega menu is click-only, which is fine for touch but slow when you're
  browsing with a mouse. This adds open-on-hover as a progressive enhancement:
  native <details> click and keyboard behaviour are left completely intact, and
  nothing here runs on touch devices or narrow viewports.
*/
(function () {
  'use strict';

  var OPEN_DELAY = 90;
  var CLOSE_DELAY = 220;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var isDesktop = window.matchMedia('(min-width: 990px)');

  function enhance(nav) {
    if (nav.dataset.tbMegaBound === 'true') return;
    nav.dataset.tbMegaBound = 'true';

    var openTimer = null;
    var closeTimer = null;

    function menus() {
      return Array.prototype.slice.call(nav.querySelectorAll('header-menu details.tb-mega'));
    }

    function active() {
      return canHover.matches && isDesktop.matches;
    }

    function closeAll(except) {
      menus().forEach(function (details) {
        if (details === except || !details.open) return;
        details.removeAttribute('open');
        var summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      });
    }

    function open(details) {
      if (details.open) return;
      closeAll(details);
      details.setAttribute('open', '');
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
      // details-disclosure.js listens for `toggle` to hold the sticky header open.
      details.dispatchEvent(new Event('toggle'));
    }

    function clearTimers() {
      if (openTimer) clearTimeout(openTimer);
      if (closeTimer) clearTimeout(closeTimer);
      openTimer = closeTimer = null;
    }

    menus().forEach(function (details) {
      var host = details.parentElement; // <header-menu>

      host.addEventListener('mouseenter', function () {
        if (!active()) return;
        clearTimers();
        openTimer = setTimeout(function () {
          open(details);
        }, OPEN_DELAY);
      });

      host.addEventListener('mouseleave', function () {
        if (!active()) return;
        clearTimers();
        closeTimer = setTimeout(function () {
          // Don't yank the panel away while the user is tabbing through it.
          if (details.contains(document.activeElement)) return;
          closeAll();
        }, CLOSE_DELAY);
      });

      // A click on an already-hover-opened summary would immediately re-close
      // it, so swallow that one case.
      var summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function (event) {
          if (active() && details.open) event.preventDefault();
        });
      }
    });

    nav.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var openDetails = nav.querySelector('details.tb-mega[open]');
      if (!openDetails) return;
      closeAll();
      var summary = openDetails.querySelector('summary');
      if (summary) summary.focus();
    });
  }

  function init() {
    document.querySelectorAll('.tb-mega-nav').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders the header section on every setting change.
  document.addEventListener('shopify:section:load', init);
})();
